export var ProductFamily;
(function (ProductFamily) {
    ProductFamily[ProductFamily["Rule"] = 0] = "Rule";
    ProductFamily[ProductFamily["Workflow"] = 1] = "Workflow";
    ProductFamily[ProductFamily["StandardProduction"] = 2] = "StandardProduction";
    ProductFamily[ProductFamily["NonProduction"] = 3] = "NonProduction";
    ProductFamily[ProductFamily["Enterprise"] = 4] = "Enterprise";
    ProductFamily[ProductFamily["Development"] = 5] = "Development";
    ProductFamily[ProductFamily["UnlimitedDevelopment"] = 6] = "UnlimitedDevelopment";
    ProductFamily[ProductFamily["Repository"] = 7] = "Repository";
    ProductFamily[ProductFamily["Personal"] = 8] = "Personal";
    ProductFamily[ProductFamily["Decisions"] = 9] = "Decisions";
    ProductFamily[ProductFamily["HL7Flow"] = 10] = "HL7Flow";
    ProductFamily[ProductFamily["UnlimitedDevelopmentServer"] = 11] = "UnlimitedDevelopmentServer";
})(ProductFamily || (ProductFamily = {}));
;
